import React from 'react';
import CountUp from './CountUp';
import { motion } from "framer-motion";
const Hero = () => {
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const wordVariants = {
  hidden: {
    opacity: 0,
    y: 40,
    scaleY: 0.7,
    transformOrigin: "bottom",
  },
  visible: {
    opacity: 1,
    y: 0,
    scaleY: 1,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};
  return (
    <section id="hero">
      <div className="pbg">
        <img src="/trichy-hero-bg.png" alt="Trichy Rockfort Landmark" style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: '0.7' }} />
      </div>
      <div className="hfade"></div>
      <div className="hbody">
        {/* <div className="heye">TRICHY DTCP PLOTS — Saravanan, Trichy</div>
        <h1 className="ht">
          <span className="fl"><span className="an-wrd">TRICHY</span></span><br />
          <span className="it"><span className="an-wrd">DTCP</span> <span className="an-wrd">PLOTS</span></span><br />
          <span className="sm"><span className="an-wrd">Saravanan,</span> <span className="an-wrd">Land</span> <span className="an-wrd">Consultant</span></span>
        </h1> */}
        <motion.div
          className="heye"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          TRICHY DTCP PLOTS — Saravanan, Trichy
        </motion.div>

        <motion.h1
          className="ht"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <span className="fl">
            <motion.span className="an-wrd" variants={wordVariants}>
              TRICHY
            </motion.span>
          </span>

          <br />

          <span className="it">
            <motion.span className="an-wrd" variants={wordVariants}>
              DTCP
            </motion.span>{" "}

            <motion.span className="an-wrd" variants={wordVariants}>
              PLOTS
            </motion.span>
          </span>

          <br />

          <span className="sm">
            <motion.span className="an-wrd" variants={wordVariants}>
              Saravanan,
            </motion.span>{" "}

            <motion.span className="an-wrd" variants={wordVariants}>
              Land
            </motion.span>{" "}

            <motion.span className="an-wrd" variants={wordVariants}>
              Consultant
            </motion.span>
          </span>
        </motion.h1>
        <p className="hsub">
          <span className="an-wrd">Looking</span> <span className="an-wrd">for</span> <span className="an-wrd">the</span> <span className="an-wrd">perfect</span> <span className="an-wrd">DTCP</span> <span className="an-wrd">plots</span> <span className="an-wrd">for</span> <span className="an-wrd">sale</span> <span className="an-wrd">in</span> <span className="an-wrd">Trichy?</span> <span className="an-wrd">I</span> <span className="an-wrd">personally</span> <span className="an-wrd">guide</span> <span className="an-wrd">you</span> <span className="an-wrd">from</span> <span className="an-wrd">site</span> <span className="an-wrd">visit</span> <span className="an-wrd">to</span> <span className="an-wrd">registration</span> <span className="an-wrd">—</span> <span className="an-wrd">no</span> <span className="an-wrd">agents,</span> <span className="an-wrd">no</span> <span className="an-wrd">middlemen,</span> <span className="an-wrd">just</span> <span className="an-wrd">me.</span>
        </p>
        <div className="hbtns">
          <a href="#locations" className="bg">View My Listings</a>
          
          <a href="#contact" className="bw">Talk to Me</a>
        </div>
      </div>
      <div className="hstats">
        <div className="hst">
          <div className="hstn"><CountUp end={200} suffix="+" /></div>
          <div className="hstl">Plots Sold</div>
        </div>
        <div className="hst">
          <div className="hstn"><CountUp end={10} suffix="+" /></div>
          <div className="hstl">Years Exp.</div>
        </div>
        <div className="hst">
          <div className="hstn"><CountUp end={5} /></div>
          <div className="hstl">Key Areas</div>
        </div>
      </div>
      <div className="scue">
        <div className="sbar"></div>
        Scroll Down
      </div>
    </section>
  );
};

export default Hero;
